export default "__VITE_ASSET__CEjVCA20__"